var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoSubtracao01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1259_1_",
    transform: "translate(-1.151 27.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1258_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745_1_",
    d: "M34.8-11.8H3.5c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h31.3c1,0,1.8-0.8,1.8-1.8S35.8-11.8,34.8-11.8z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoSubtracao01);
export default __webpack_public_path__ + "static/media/ico-funcao-subtracao-01.86507776bddc3aac988494519020b681.svg";
export { ForwardRef as ReactComponent };